export default "/_next/static/images/roche-2482a891ebc8cb60142818b2b6dda590.svg";